import ContactService from '../../../services/contact_service';
import PermissionService from '../../../services/permission_service';
import { iqualsArrays } from '../../../utils';

const PermissionGuard = ({
  currentUser,
  permission,
  updateMessage,
  showSessionExpiredOnce,
  handleLogout,
  resetSessionExpiredFlag,
}) => {
  const closeByAccessChange = async (message) => {
    updateMessage(message, 'error', 'access-changed');
    await handleLogout(resetSessionExpiredFlag, true);
  };

  const expireSesion = (response) => {
    if (response === 'unauthorized') {
      showSessionExpiredOnce();
      handleLogout(resetSessionExpiredFlag, true);
      return true;
    }
    return false;
  };

  const losesAccess = async () => {
    try {
      if (!currentUser) return false;
      const permissions = await PermissionService.getByRole(currentUser.FK_Role);
      if (await expireSesion(permissions)) return true;
      const permissionCodes = permissions?.map((p) => Number(p.Code));
      const user = await ContactService.get(currentUser?.Id);
      if (await expireSesion(user)) return true;
      if (user.FK_Role !== currentUser.FK_Role) {
        await closeByAccessChange(
          'El administrador cambio el rol del usuario, ingrese de nuevo'
        );
        return true;
      } else if (!iqualsArrays(permissionCodes, permission)) {
        await closeByAccessChange(
          'Se actualizaron los permisos de acceso a este rol, ingrese de nuevo'
        );
        return true;
      }
      return false;
    } catch (e) {
      await closeByAccessChange(
        'Se actualizaron los permisos de acceso a este rol, ingrese de nuevo'
      );
      return true;
    }
  };

  return {
    expireSesion,
    losesAccess,
  };
};

export default PermissionGuard;
